import { Box, Group, PasswordInput, ActionIcon, Tooltip, Progress, Badge } from '@mantine/core'
import { IconWand, IconCopy, IconCheck } from '@tabler/icons-react'
import { useState } from 'react'
import { generatePassword, passwordStrength } from './novaSenha'

interface CampoNovaSenhaProps {
  value: string
  onChange: (valor: string) => void
  /** Chamado depois de gerar: quem usa limpa a confirmacao, que deixou de bater. */
  onGerada?: () => void
  /** So o texto de ajuda: quem decide se pode enviar e o cartao. */
  minimo?: number
}

/**
 * "Nova senha" com gerador, copiar e medidor — o mesmo bloco no cartao da senha do
 * login e no da senha UNIX, para os dois nao divergirem.
 */
export function CampoNovaSenha({ value, onChange, onGerada, minimo = 8 }: CampoNovaSenhaProps) {
  const [copied, setCopied] = useState(false)
  const strength = passwordStrength(value)

  const handleGenerate = () => { onChange(generatePassword()); onGerada?.(); setCopied(false) }
  const handleCopy = () => {
    navigator.clipboard.writeText(value); setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Box>
      <Group gap="xs" align="flex-end">
        <PasswordInput
          label="Nova senha"
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
          placeholder={`Mínimo ${minimo} caracteres`}
          style={{ flex: 1 }}
          data-sensitive="true"
          wrapperProps={{ 'data-sensitive': 'true' }}
        />
        <Tooltip label="Gerar senha segura">
          <ActionIcon variant="light" color="violet" size="lg" mb={1} onClick={handleGenerate} aria-label="Gerar senha segura">
            <IconWand size={16} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label={copied ? 'Copiado!' : 'Copiar senha'}>
          <ActionIcon
            variant="light"
            color={copied ? 'teal' : 'gray'}
            size="lg"
            mb={1}
            disabled={!value}
            onClick={handleCopy}
            aria-label="Copiar senha"
          >
            {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
          </ActionIcon>
        </Tooltip>
      </Group>
      {value && (
        <Group gap="xs" mt={6} align="center">
          <Progress value={strength.score} color={strength.color} size="xs" style={{ flex: 1 }} />
          <Badge size="xs" color={strength.color} variant="light">{strength.label}</Badge>
        </Group>
      )}
    </Box>
  )
}
